import { render, staticRenderFns } from "./Artworks.vue?vue&type=template&id=83089cb8&scoped=true"
import script from "./Artworks.vue?vue&type=script&lang=js"
export * from "./Artworks.vue?vue&type=script&lang=js"
import style0 from "./Artworks.vue?vue&type=style&index=0&id=83089cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83089cb8",
  null
  
)

export default component.exports